// extracted by mini-css-extract-plugin
module.exports = {"container":"Legal_container__36mWL","content":"Legal_content__soccO","intro":"Legal_intro__1wDIX","end":"Legal_end__3HapI"};